import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useState, useEffect, useRef } from 'react'
import FormInput from '../../components/forms/formInput'
import FormSelect from '../../components/forms/formSelect'
import GreenButton from '../../components/forms/greenButton'
import FormError from '../../components/forms/formError'
import ApiUrl from '../../configTools/apiUrl'

const Menuedit = () => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const navigate = useNavigate();
    const typeArray = [
        {name:'CustomUrl', value:'CustomUrl'},
        {name:'Category', value:'Category'},
        {name:'Collection', value:'Collection'}
    ]
    const {id} = useParams();
    const [name,setName] = useState('');
    const [type,setType] = useState({name:'Select', value:'0'});
    const [url,setUrl] = useState('');
    const [parent,setParent] = useState({name:'Select', value:'0'});
    const [parentList,setParentList] = useState([]);
    const [category,setCategory] = useState({name:'Select', value:'0'});
    const [categoryList,setCategoryList] = useState([]);
    const [collection,setCollection] = useState({name:'Select', value:'0'});
    const [collectionList,setCollectionList] = useState([]);
    const CustomUrl = useRef(null);
    const CategoryUrl = useRef(null);
    const CollectionUrl = useRef(null);
    const [error,setError] = useState("");
    function ChangeType(v){
        setUrl('');
        CustomUrl.current.className = 'forms_hidden'
        CategoryUrl.current.className = 'forms_hidden'
        CollectionUrl.current.className = 'forms_hidden'
        if(v.value === 'CustomUrl'){
          CustomUrl.current.className = 'forms_visible'
        }
        else if(v.value === 'Category'){
          CategoryUrl.current.className = 'forms_visible'
        }
        else if(v.value === 'Collection'){
          CollectionUrl.current.className = 'forms_visible'
        }
        setType(v);
    }
    function setCategoryUrl(e){
      if(e.value === '0'){
        setUrl('');
      }
      else{
        setUrl(e.value);
      }
      setCategory(e);
    }
    function setCollectionUrl(e){
      if(e.value === '0'){
        setUrl('');
      }
      else{
        setUrl(e.value);
      }
      setCollection(e);
    }
    useEffect(() => {
        fetch(ApiUrl.API_URL_Navigation)
        .then(res=>res.json())
        .then(data =>{
            let selectVal = [{name:'None', value:'0'}];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                selectVal.push({
                    name : element.name,
                    value : String(element.id)
                })
            }
            setParentList(selectVal);
            fetch(ApiUrl.API_URL_Navigation+"/"+id)
            .then(res3=>res3.json())
            .then(data3 =>{
                setName(data3.name);
                ChangeType({name:'CustomUrl', value:'CustomUrl'});
                setUrl(data3.url)
                setParent(selectVal.find(x=>x.value === String(data3.parentid)));
            });
        });
        fetch(ApiUrl.API_URL_Collection)
        .then(res2=>res2.json())
        .then(data2 =>{
            let selectCVal = [];
            for (let index = 0; index < data2.length; index++) {
                const element = data2[index];
                if(element.parentid === 0){
                    selectCVal.push({
                        name : element.id+"-"+element.title,
                      value : "/filter?category="+String(element.title)
                  });
                }
                else{
                    selectCVal.push({
                      name : element.id+"-"+element.parentid+"-"+element.title+"-"+element.parent,
                      value : "/filter?category="+element.parent+"&subcategory="+String(element.title)
                  });
                }
            }
            setCategoryList(selectCVal);
        });
        fetch(ApiUrl.API_URL_ListCollection)
        .then(res=>res.json())
        .then(data =>{
            let selectVal = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                selectVal.push({
                    name : element.name,
                    value : "/ncollection/"+String(element.id)
                });
            }
            setCollectionList(selectVal);
        });
    },[id])
    function update_admin(){
        fetch(ApiUrl.API_URL_NavigationUpdate, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            },
            body: JSON.stringify({
                id: id,
                name : name,
                type : type.value,
                url : url,
                parentid : parseInt(parent.value)
            })
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.success){
                navigate('/admin/onlinestore/navigation');
            }
            else{
                setError(data.responce);
            }
        });
    }
  return (
    <div className='admin_forms_main_container'>
        <div className='admin_forms_row'>
            <div className='admin_col_25'></div>
            <div className='admin_col_50'>
                <div className='admin_forms_title'>

                </div>
                <div className='admin_forms_container'>
                    <FormError Value={error}/>
                    <FormInput Lable='Name' Type='text' Placeholder='Enter name' Value={name} setValue={setName}/>
                    <FormSelect Lable='Type' Value={type} setValue={ChangeType} Options={typeArray}/>
                    <div className='forms_hidden' ref={CustomUrl}>
                        <FormInput Lable='CustomUrl' Type='text' Placeholder='Enter url' Value={url} setValue={setUrl}/>
                    </div>
                    <div className='forms_hidden' ref={CategoryUrl}>
                        <FormSelect Lable='Category Url' Value={category} setValue={setCategoryUrl} Options={categoryList}/>
                    </div>
                    <div className='forms_hidden' ref={CollectionUrl}>
                    <FormSelect Lable='Collection Url' Value={collection} setValue={setCollectionUrl} Options={collectionList}/>
                    </div>
                    <FormSelect Lable='Parent' Value={parent} setValue={setParent} Options={parentList}/>
                    <GreenButton Value='Update' Action={update_admin}/>
                </div>
            </div>
            <div className='admin_col_25'></div>
        </div>
    </div>
  )
}

export default Menuedit
